import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "__distributeEvenly", "position"];
import { Flex } from '../../../components/Flex/Flex';
import { jsx as _jsx } from "react/jsx-runtime";
export const SlotFlex = _ref => {
  let {
      children,
      __distributeEvenly,
      position
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const positionStyles = {
    start: {
      justifyContent: 'start'
    },
    middle: {
      justifyContent: 'center',
      flexGrow: 1,
      flexShrink: 1,
      flexBasis: 'auto',
      flexWrap: __distributeEvenly ? 'nowrap' : undefined
    },
    end: {
      justifyContent: 'end'
    }
  };
  return /*#__PURE__*/_jsx(Flex, Object.assign({}, rest, {
    alignItems: "center",
    flexShrink: 0,
    columnGap: "300"
  }, __distributeEvenly && {
    flexShrink: 1,
    flexGrow: 1,
    flexBasis: '0%'
  }, positionStyles[position], {
    children: children
  }));
};